import React, { CSSProperties } from 'react'
import { useDispatch } from 'react-redux'
import { AchievementItemType } from '../../containers/ProfileAchievementsPage/types'
import * as profileActions from '../../containers/SignInPage/actions'

// Styles
import './styles.scss'

export default ({
  title,
  achievements,
  countOpened,
  hideAllCount,
  style,
}: {
  title: string
  achievements: AchievementItemType[]
  countOpened: number
  hideAllCount?: boolean
  style?: CSSProperties
}) => {
  const dispatch = useDispatch()

  return (
    <div className={'achievements-block'} style={style}>
      <div className={'header'}>
        <div className={'header__title'}>Достижения {title}</div>
        <div className={'header__process'}>
          открыто {countOpened}{' '}
          {hideAllCount ? null : `/ ${achievements.length}`}
        </div>
      </div>
      <div className={'row'}>
        {achievements.map(item => (
          <div key={item.achievement_id} className={'row__item'}>
            <div
              className={'outer'}
              onClick={() =>
                dispatch(profileActions.setSelectedAchievement(item))
              }
            >
              <div
                className={
                  item.user_achievement
                    ? 'outer__icon'
                    : 'outer__icon grayscale'
                }
              >
                {item.image_media ? <img src={item.image_media.url} /> : null}
              </div>
              <div className={'outer__title'}>{item.caption}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
